<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>购买优惠券</span>
            <div>
              <el-button type="primary" size="small" @click="_closeBuyGold">
                <i class="el-icon-close"></i> 返回
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-form label-position="right" label-width="120px">
              <el-form-item label="优惠券">
                <el-input v-model="buyGoldInfo.couponName" disabled placeholder="优惠券"></el-input>
              </el-form-item>
              <el-form-item label="库存">
                <el-input v-model="buyGoldInfo.couponStock" disabled placeholder="库存"></el-input>
              </el-form-item>
              <el-form-item label="优惠券价格">
                <el-input v-model="buyGoldInfo.buyPrice" disabled placeholder="优惠券价格"></el-input>
              </el-form-item>
              <el-form-item label="优惠券数量">
                <el-input 
                  v-model="buyGoldInfo.goldCount" 
                  type="number" 
                  @change="_changeGoldCount"
                  placeholder="必填，请填写购买优惠券数量"></el-input>
              </el-form-item>
              <el-form-item label="支付金额">
                <el-input v-model="buyGoldInfo.goldMoney" disabled placeholder="支付金额"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 20px;">
        <el-button type="primary" class="float-right" @click="_toBuyGold">
          <i class="el-icon-check"></i>&nbsp;购买
        </el-button>
      </el-col>
    </el-row>

    <el-dialog 
      title="扫码支付" 
      :visible.sync="dialogVisible" 
      width="70%"
      :before-close="handleClose">
      <div class="dialog-body">
        <el-row>
          <el-col :span="24">
            <h3 class="m-t-none m-b">扫码支付</h3>
            <el-card class="box-card">
              <el-form label-position="right" label-width="120px">
                <el-form-item label="支付二维码">
                  <el-col :span="8">
                    <div style="position: relative;">
                      <img 
                        v-if="buyGoldInfo.showRefresh"
                        @click="_changeAppType"
                        src="/img/qrcode-refresh.png" 
                        style="position: absolute; top: 0; left: 15px;"
                        width="200" 
                        height="200" 
                        alt="">
                      <div id="qrcode" style="width:200px; height:200px;"></div>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <span>请用微信扫码支付</span>
                  </el-col>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="_finishScanQrCode">支付完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { listCouponPool, toQrPayGold } from '@/api/goods/buyGoldApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'BuyGold',
  data() {
    return {
      dialogVisible: false,
      buyGoldInfo: {
        poolId: '',
        actualPrice: '0',
        buyPrice: '0',
        couponName: '0',
        couponStock: '0',
        couponType: '',
        goldCount: '0',
        goldMoney: '0',
        payQrCode: '',
        shopId: getShopId(),
        showRefresh: false
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    _initData() {
      this.buyGoldInfo.poolId = this.$route.query.poolId
      this._listProducts()
    },
    _listProducts() {
      const params = {
        page: 1,
        poolId: this.buyGoldInfo.poolId,
        row: 1
      }
      
      listCouponPool(params)
        .then(response => {
          const data = response.data[0]
          Object.assign(this.buyGoldInfo, data)
          this._changeGoldCount()
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    _closeBuyGold() {
      this.dialogVisible = false
      this.$router.push('/pages/goods/couponShopPoolManage')
    },
    _changeGoldCount() {
      const goldMoney = this.buyGoldInfo.buyPrice * this.buyGoldInfo.goldCount
      this.buyGoldInfo.goldMoney = goldMoney.toFixed(2)
    },
    _toBuyGold() {
      this.buyGoldInfo.payQrCode = ''
      toQrPayGold(this.buyGoldInfo)
        .then(response => {
          if (response.code === 0) {
            this.buyGoldInfo.payQrCode = response.codeUrl
            this._viewQr(this.buyGoldInfo.payQrCode)
            this.dialogVisible = true
            this.$message.success(response.msg)
          }
        })
        .catch(error => {
          console.error('请求失败:', error)
          this.$message.error(error)
        })
    },
    _viewQr(url) {
      document.getElementById("qrcode").innerHTML = ""
      new QRCode(document.getElementById("qrcode"), {
        text: url,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    _finishScanQrCode() {
      this._closeBuyGold()
    },
    _changeAppType() {
      console.log('_changeAppType')
    },
    handleClose(done) {
      done()
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}
.m-t-none {
  margin-top: 0;
}
.m-b {
  margin-bottom: 15px;
}
</style>